import axios from "axios/index";
/**
 * 电池型号js文件
 * @param params
 * @returns {Promise<any | {code: number, message: string}>}
 */
export const getList = params => axios.post('/business/batteryModel/list', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});

export const create = params => axios.post('/business/batteryModel/add', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});

export const update = params => axios.post('/business/batteryModel/update', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});

export const del = id => axios.post('/business/batteryModel/delete', {id}).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});

export const detail = id => axios.post('/business/batteryModel/detail', {id}).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});



